import * as React from 'react';
import DateRange from 'src/components/common/DateRange';
import './TrackingFilterBar.scss';
import DateRangeModel from 'src/model/dateRange.model';

interface ITrackFilterbarProps {
  t: any;
  filters: {
    dates: DateRangeModel | null;
    search: string;
  };
  handleDateFilter: (dates: DateRangeModel) => void;
}

class TrackingFilterbar extends React.Component<ITrackFilterbarProps, any> {
  private handleDateFilter = (dateRange: DateRangeModel | null) => {
    this.props.handleDateFilter(dateRange);
  };

  public render() {
    const { t } = this.props;

    return (
      <React.Fragment>
        <div className="rp-tracking-filterbar">
          <div className="rp-tracking-filterbar--filters">
            <div className="title">
              <span>{t('common.filterBy')}:</span>
            </div>
            <div className="filters-components">
              <div className="date-range-container">
                <DateRange
                  onDatesSelected={this.handleDateFilter}
                  dates={this.props.filters.dates}
                  onClear={() => {
                    this.handleDateFilter(null);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TrackingFilterbar;
